<template>
  <section>
    <el-row class="layout3" :gutter="20">
      <el-col v-for="(item, index) in list" :key="index" :span="span">
        <div class="layout3-item" @click="handleRoute(item.id)">
          <span>
            <img
              :src="item.cover_pic"
              alt=""
              :style="{ height: `${imgHeight}px` }"
            />
          </span>
          <span>{{ item.name }}</span>
          <span>
            <img :src="require(`@/assets/icon/icon-show3.png`)" alt="" />
            <span>
              {{ item.look_num }}
            </span>
            <img :src="require(`@/assets/icon/icon-endorse3.png`)" alt="" />
            <span>{{ item.like_num }}</span>
          </span>
        </div>
      </el-col>
    </el-row>
  </section>
</template>

<script>
export default {
  name: "comLayout3",
  components: {},
  props: {
    imgHeight: {
      type: Number,
      default: 200,
    },
    span: {
      type: Number,
      default: 6,
    },
    list: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },
  computed: {
    configList() {
      return this.list.length ? Object.keys(this.list[0]) : [];
    },
  },
  watch: {},
  data() {
    return {};
  },
  mounted() {},
  methods: {
    handleRoute(v) {
      this.$emit("path", v);
    },
  },
};
</script>

<style scoped lang="scss">
.layout3 {
  margin-top: 22px;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  overflow: hidden;
  > div {
    margin-bottom: 30px;
    margin-top: 10px;
    overflow: visible;
  }
  &-item {
    cursor: pointer;
    height: 100%;
    background-color: #fff;
    border-radius: 6px;
    box-shadow: 0px 0px 4px 3px rgba(85, 85, 85, 0.03);
    margin:5px;
    margin-left: 13px;
    overflow: hidden;
    &:hover {
      box-shadow: 0 0 5px 4px rgba(248, 166, 166, 0.04);
      > span:nth-child(1) img {
        transform: scale(1.1);
        transition: all 0.6s;
      }
    }
    > span {
      display: block;
      &:nth-child(1) {
        margin-bottom: 28px;
        overflow: hidden;
        > img {
          width: 100%;
        }
      }
      &:nth-child(2) {
        margin-bottom: 22px;
        margin-left: 20px;
        @include fun-design(5);
      }
      &:nth-child(3) {
        margin-bottom: 17px;
        padding-right: 20px;
        font-size: 14px;
        color: #afaeae;
        text-align: right;
        > img {
          margin-left: 16px;
        }
      }
    }
  }
}
</style>